import Icons from './utils/Icons';
import Swiper from 'swiper/bundle';
class Main {
  constructor() {
    this.init();
  }

  init() {
    Icons.load();
    this.initSwiperPagination();
    this.initSwiperPagination2();
    const btnOpen = document.querySelector('.js-toggle');
    btnOpen.addEventListener('click', this.onOpenNav);
    const btnClose = document.querySelector('.js-close');
    btnClose.addEventListener('click', this.onCloseNav);
  }
  initSwiperPagination() {
    const target = document.querySelector('.swiper-conferences');
    if (target) {
      const swiper = new Swiper(target, {
        loop: true,
        pagination: {
          el: target.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    }
  }
  initSwiperPagination2() {
    const target = document.querySelector('.swiper-conferenciers');
    if (target) {
      const swiper = new Swiper(target, {
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: target.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          800: {
            slidesPerView: 2,
          },
        },
      });
    }
  }
  onOpenNav() {
    const open = document.documentElement.classList.add('nav-is-active');
  }
  onCloseNav() {
    const close = document.documentElement.classList.remove('nav-is-active');
  }
}
new Main();
